import React from "react";

interface OrderViewModalProps {
  onClose: () => void;
  open: boolean;
  order: any;
}

const OrderViewModal: React.FC<OrderViewModalProps> = ({
  onClose,
  open,
  order,
}) => {
  if (!open || !order) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="w-full max-w-md rounded-lg bg-white p-6 shadow-lg dark:bg-gray-900"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="mb-4 text-xl font-bold text-gray-900 dark:text-gray-100">
          View Order
        </h2>
        <div className="space-y-2">
          <div>
            <span className="font-semibold">Item:</span> {order.item}
          </div>
          <div>
            <span className="font-semibold">Status:</span> {order.status}
          </div>
          <div>
            <span className="font-semibold">Customer:</span> {order.customer}
          </div>
        </div>
        <button
          className="mt-6 rounded bg-blue-600 px-4 py-2 text-white"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default OrderViewModal;
